import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M4.272 9.93A8 8 0 0 1 18.93 8l.306.694m-3.94.012h3.79q.076 0 .15-.012A.914.914 0 0 0 20 7.792V4M4 19.999v-3.79a.914.914 0 0 1 .914-.915m0 0h3.792m-3.792 0 .158.706a8 8 0 0 0 14.656-1.93"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }